/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useMemo } from "react";
import { DocumentTableCellV2 } from "./document-cell-v2";

export const DocumentListingV3 = ({ data: tableData, parentKey }: any) => {
  const header: string[] = useMemo(() => {
    try {
      return Object.keys(tableData[0]);
    } catch (_error) {
      return [];
    }
  }, [tableData]);

  const getRow = (prop: any) => {
    try {
      return Object.entries(prop);
    } catch (_error) {
      return [];
    }
  };
  return (
    <div className="border overflow-auto rounded-sm">
      <Table>
        <TableHeader>
          <TableRow>
            {header.map((HeaderCell, headerCellIndex: number) => {
              return (
                <DocumentTableCellV2
                  data={HeaderCell}
                  key={headerCellIndex}
                  keyValue={HeaderCell}
                  parentKey={`${parentKey}.${headerCellIndex}.${HeaderCell}`}
                  isHeader={true}
                />
              );
            })}
          </TableRow>
        </TableHeader>
        <TableBody>
          {tableData.map((rowValue: any, rowIndex: number) => {
            const row = getRow(rowValue);
            return (
              <TableRow key={rowIndex}>
                {row.map(([key, value]: any, cellIndex: number) => {
                  return (
                    <TableCell key={key + cellIndex}>
                      <DocumentTableCellV2
                        data={value}
                        key={rowIndex}
                        keyValue={key}
                        parentKey={`${parentKey}.${rowIndex}.${key}`}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
